import React from "react";
import { UseFormRegister } from "react-hook-form";
import Hint from "components/shared/fields/Hint";
import Label from "components/shared/form/Label";
import useRegisterPropOrFromContext from "components/shared/form/fields/useRegisterPropOrFromContext";

type InputArgs = {
  name: string;
  label?: string;
  required?: boolean;
  defaultValue?: string;
  register?: UseFormRegister<any>;
  options: {
    label: string | React.ReactElement;
    value: string;
    disabled?: boolean;
  }[];
  hint?: string;
  withoutWrapper?: boolean;
  extraElement?: React.ReactElement;
};

export default function RadioButton({
  name,
  register,
  label,
  options,
  hint,
  required,
  defaultValue,
  extraElement,
  withoutWrapper = false,
}: InputArgs) {
  register = useRegisterPropOrFromContext(register);

  const renderedOptions = options.map((option) => (
    <label key={option.value} className="radio gap-2 items-center">
      <input
        type="radio"
        value={option.value}
        {...(register ? register(name) : null)}
        defaultChecked={option.value === defaultValue}
        disabled={option.disabled}
      />
      {option.label}
    </label>
  ));

  return withoutWrapper ? (
    <div className="flex flex-col gap-2 mt-2 items-start">
      {label && <Label label={label} required={required} />}
      <div>{renderedOptions}</div>
      {hint && <Hint hint={hint} />}
    </div>
  ) : (
    <div className="control-group">
      {label && <Label label={label} required={required} />}
      <div className="controls white-box checkboxes border-box p-3">
        {renderedOptions}
        {hint && <Hint hint={hint} />}
        {extraElement}
      </div>
    </div>
  );
}
